import "./style.css"

const PublicationsPage = () => {
    return (
        <div className="center-text">
            <div className="publication">
                Talpade, A. D.; Ghanekar, P.; Ezenwa, S.; Joshi, R.; Kravitz, S.; Tunga, A.; Devaraj, J.; Ribeiro, F. H.; Mentzer, R. "Promoting a Safe Laboratory Environment Using the Reactive Hazard Evaluation and Analysis Compilation Tool." 
ACS Chem. Health Saf. 2021, 28 (2), 134–143. <a target="_blank" href="https://doi.org/10.1021/acs.chas.1c00006">https://doi.org/10.1021/acs.chas.1c00006</a>. (<a target="_blank" href="https://drive.google.com/file/d/1SCUpkDs6eSpjCr4f0Hw6kIOxHkQk-QpG/view?usp=sharing">PDF</a>, <a target="_blank" href="https://drive.google.com/file/d/16DNmO8fP2kx-xA-6srTgco4PgWV2Sdgw/view?usp=sharing">SI</a>)
            </div>
            <div className="publication">
                Ezenwa, S.; Talpade, A. D.; Ghanekar, P.; Joshi, R.; Devaraj, J.; Ribeiro, F. H.; Mentzer, R. “Toward Improved Safety Culture in Academic and Industrial Chemical Laboratories: An Assessment and Recommendation of Best Practices.” 
    ACS Chem. Health Saf. 2022, 29 (2), 202–213. <a target="_blank" href="https://doi.org/10.1021/acs.chas.1c00064">https://doi.org/10.1021/acs.chas.1c00064</a>. (<a target="_blank" href="https://drive.google.com/file/d/1UyblANoXmzXKL_a6zMXjMeh6FRvGu5-3/view?usp=sharing">PDF</a>, <a target="_blank" href="https://drive.google.com/file/d/1AHlKBnjZ7ceeGee_kJuyUBJl9GMNgk_S/view?usp=sharing">SI</a>)
            </div>
            <div className="publication">
                Dow’s Chemical Exposure Index Guide, 1st ed.; John Wiley & Sons, Ltd, 1998. <a target="_blank" href="https://doi.org/10.1002/9780470935309">https://doi.org/10.1002/9780470935309</a>.
            </div>
        </div>
    );
};

export default PublicationsPage;
